import React from 'react';
import PropTypes from 'prop-types';
import MediaQueries from 'react-responsive';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import Image from 'marketing-website/components/modules/Image';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';
import assets from 'marketing-website/configs/pages/pop/sketches';

export default function SketchBlock() {
  return (
    <PageWrap size="l">
      <Spacing size="xl" type="padding" position="topBottom">
        <Grid columns={12} alignItems="center">
          <GridItem columnSpan={12} columnSpanM={5}>
            <MediaQueries minWidth={770}>
              <HeadingBlock
                justifyContent="center"
                justifyM="start"
                maxWidth={430}
                title="Turn any sketch or image into an interactive prototype."
                copy="Quickly snap your sketches and then together to simulate your app idea."
              />
            </MediaQueries>
          </GridItem>
          <GridItem columnSpan={12} columnSpanM={7}>
            <MediaMultipleImages
              fallbackImageAlt={assets.iPhoneSketches.alt}
              fallbackImageSrc={assets.iPhoneSketches.src}
              fallbackImageMaxWidth={assets.iPhoneSketches.maxWidth}
            >
              <Shape
                type="rectangle"
                color="brightOrange"
                width={425}
                height={314}
              />
              <ParallaxWrapper speed={1}>
                <Pattern
                  color="orangeLight"
                  left="46%"
                  top="35%"
                  type="shortRectangle"
                />
                <Pattern
                  color="orangeLight"
                  left="10%"
                  top="42%"
                  type="shortRectangle"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={1.7}>
                <ParallaxWrapper>
                  <Image
                    {...assets.friendsSketch}
                    borderRadius="m"
                    right="4%"
                    maxWidth={assets.friendsSketch.maxWidth}
                    position="absolute"
                    bottom="15%"
                  />
                </ParallaxWrapper>
                <Image
                  {...assets.iPhone}
                  borderRadius="m"
                  left="33%"
                  position="absolute"
                  top="15%"
                />
                <ParallaxWrapper>
                  <Image
                    {...assets.togglesSketch}
                    borderRadius="m"
                    left="6%"
                    maxWidth={assets.togglesSketch.maxWidth}
                    position="absolute"
                    top="22%"
                  />
                </ParallaxWrapper>
              </ParallaxWrapper>
            </MediaMultipleImages>
            <MediaQueries maxWidth={769}>
              <HeadingBlock
                justifyContent="center"
                justifyM="start"
                maxWidth={430}
                title="Turn any sketch or image into an interactive prototype."
                copy="Quickly snap your sketches and then together to simulate your app idea."
              />
            </MediaQueries>
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pop/Sketching.js